module.exports = __webpack_public_path__ + "08b770b7f5982f6df2e78132a6707cae.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solar.png
// module id = 1927
// module chunks = 0